export default function LoadD() {
  return (
    <div
      className="ion-icon-load-d"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M432,240h-80c-8.8,0-16,7.2-16,16s7.2,16,16,16h80c8.8,0,16-7.2,16-16S440.8,240,432,240z"/>
	<path d="M176,256c0-8.8-7.2-16-16-16H80c-8.8,0-16,7.2-16,16s7.2,16,16,16h80C168.8,272,176,264.8,176,256z"/>
	<path d="M256,336c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16s16-7.2,16-16v-80C272,343.2,264.8,336,256,336z"/>
	<path d="M256,64c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16s16-7.2,16-16V80C272,71.2,264.8,64,256,64z"/>
	<path d="M325.3,216c4.4,7.7,14.2,10.3,21.9,5.9l69.3-40c7.7-4.4,10.3-14.2,5.9-21.9s-14.2-10.3-21.9-5.9l-69.3,40
		C323.5,198.6,320.9,208.3,325.3,216z"/>
	<path d="M186.7,296c-4.4-7.7-14.2-10.3-21.9-5.9l-69.3,40c-7.7,4.4-10.3,14.2-5.9,21.9s14.2,10.3,21.9,5.9l69.3-40
		C188.5,313.4,191.1,303.7,186.7,296z"/>
	<path d="M317.9,331.1c-4.4-7.7-14.2-10.3-21.9-5.9s-10.3,14.2-5.9,21.9l40,69.3c4.4,7.7,14.2,10.3,21.9,5.9
		c7.7-4.4,10.3-14.2,5.9-21.9L317.9,331.1z"/>
	<path d="M181.9,95.6c-4.4-7.7-14.2-10.3-21.9-5.9c-7.7,4.4-10.3,14.2-5.9,21.9l40,69.3c4.4,7.7,14.2,10.3,21.9,5.9
		s10.3-14.2,5.9-21.9L181.9,95.6z"/>
	<path d="M296,186.7c7.7,4.4,17.4,1.8,21.9-5.9l40-69.3c4.4-7.7,1.8-17.4-5.9-21.9c-7.7-4.4-17.4-1.8-21.9,5.9l-40,69.3
		C285.7,172.5,288.3,182.3,296,186.7z"/>
	<path d="M216,325.3c-7.7-4.4-17.4-1.8-21.9,5.9l-40,69.3c-4.4,7.7-1.8,17.4,5.9,21.9c7.7,4.4,17.4,1.8,21.9-5.9l40-69.3
		C226.3,339.5,223.7,329.7,216,325.3z"/>
	<path d="M416.4,330.1l-69.3-40c-7.7-4.4-17.4-1.8-21.9,5.9c-4.4,7.7-1.8,17.4,5.9,21.9l69.3,40c7.7,4.4,17.4,1.8,21.9-5.9
		C426.7,344.3,424.1,334.6,416.4,330.1z"/>
	<path d="M95.6,181.9l69.3,40c7.7,4.4,17.4,1.8,21.9-5.9s1.8-17.4-5.9-21.9l-69.3-40c-7.7-4.4-17.4-1.8-21.9,5.9
		C85.3,167.7,87.9,177.4,95.6,181.9z"/>
</g>
</svg>
`,
      }}
    />
  )
}
